import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ArrowLeft, X as CloseX } from "lucide-react";
import { AuthContext } from "../../../context/authContext";
import { convertDateFormatInUtc, convertDateToCT } from "../../../utils/util";
import { getUsers } from "../../../utils/getUser";
import { Button } from "../../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../../components/ui/dialog";
import { Label } from "../../../components/ui/label";
import { Textarea } from "../../../components/ui/textarea";

const ViewUserPaymentPage = () => {
  const [payoutType, setPayoutType] = useState("ACH");
  const [paymentDetails, setPaymentDetails] = useState({});
  const [showLoader, setShowLoader] = useState(false);
  const [approvePayout, setApprovePayout] = useState(false);
  const [openRejectPayout, setOpenRejectPayout] = useState(false);
  const [notes, setNotes] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { showToast } = useContext(AuthContext);

  useEffect(() => {
    setPayoutType(location.state?.payoutDetail?.payment_method);
    setPaymentDetails(location.state?.payoutDetail);
  }, []);

  const PaypalColumns = [
    { key: "account_holder_name", label: "Full Name" },
    { key: "payment_method", label: "Payment Method" },
    { key: "email", label: "Email Address" },
    { key: "paypal_username", label: "Paypal Username" },
  ];
  const AchColumns = [
    { key: "account_holder_name", label: "Full Name" },
    { key: "payment_method", label: "Payment Method" },
    { key: "phone_number", label: "Phone Number" },
    { key: "email", label: "Email Address" },
    { key: "account_last_four", label: "Account Number" },
  ];

  const columns = payoutType === "ACH" ? AchColumns : PaypalColumns;

  return (
    <>
      {showLoader && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 70,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(0,0,0,0.35)",
            color: "#fff",
            fontSize: 13,
            fontWeight: 700,
          }}
        >
          Loading...
        </div>
      )}

      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "24px 16px" }}>
        <div
          style={{
            width: "100%",
            maxWidth: 760,
            padding: "24px",
            backgroundColor: "#101010",
            borderRadius: "10px",
            marginBottom: "3rem",
            marginTop: "3rem",
            border: "1px solid rgba(255,255,255,0.12)",
            display: "flex",
            flexDirection: "column",
            gap: 16,
          }}
        >
          <button
            type="button"
            onClick={() => navigate(-1)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              color: "#c3c8cc",
              background: "transparent",
              border: "none",
              padding: 0,
              cursor: "pointer",
              fontSize: 13,
            }}
          >
            <ArrowLeft size={16} /> Back
          </button>

          <h2 style={{ fontSize: "1.7rem", color: "white", fontWeight: 700, margin: 0 }}>
            Payment Details
          </h2>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 16px" }}>
            {columns.map((item, index) => (
              <React.Fragment key={index}>
                <span style={{ fontSize: 16, color: "gray", alignSelf: "center" }}>{item.label}</span>
                <span
                  style={{
                    fontSize: 15,
                    color: "white",
                    textTransform: item.key === "email" ? "none" : "capitalize",
                    alignSelf: "center",
                  }}
                >
                  {item.key === "account_last_four" && paymentDetails[item.key]
                    ? `****${paymentDetails[item.key]}`
                    : paymentDetails[item.key] || "NA"}
                </span>
              </React.Fragment>
            ))}
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 8 }}>
            <Button variant="outline" onClick={() => setOpenRejectPayout(true)}>
              Deny
            </Button>
            <Button onClick={() => navigate("/dashboard/payouts/update-details")}>
              Approve Request
            </Button>
          </div>
        </div>
      </div>

      {/* REJECT DIALOG */}
      <Dialog open={openRejectPayout} onOpenChange={setOpenRejectPayout}>
        <DialogContent showCloseButton={false}>
          <DialogHeader>
            <DialogTitle>Are you sure you want to reject this request?</DialogTitle>
            <DialogDescription>
              This action will notify the member of your decision. You can provide a reason in the
              notes section below to help them understand the denial.
            </DialogDescription>
          </DialogHeader>

          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <Label>Reason</Label>
            <Textarea
              value={notes}
              placeholder="Provide a reason here"
              onChange={(e) => setNotes(e.target.value)}
              rows={4}
            />
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setOpenRejectPayout(false)}>
              Cancel
            </Button>
            <Button variant="outline" onClick={() => setOpenRejectPayout(false)}>
              Deny
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ViewUserPaymentPage;
